import { post } from '@/utils/request'

/**
 * 检查淘客关注公众号,并进行微信与授权支付宝的绑定
 * @param {string} app_auth_code 支付宝授权的code
 */
export default function taoke_follow_wx_check(app_auth_code) {
  return post('taoke_follow_wx_check', {app_auth_code})
}